export const audienceErrorMessageMap = {
  /* Name and Id */
  DuplicateAudienceId: 'Manage_Error_DuplicateAudienceId',
  AudienceIdsNotPassed: 'Manage_Error_AudienceIdsNotPassed',
  InvalidRemessagingAudience: 'Manage_Error_InvalidRemessagingAudience',
  InvalidAudienceId: 'Manage_Error_InvalidAudienceId',
  DuplicateAudienceName: 'Manage_Error_DuplicateAudienceName', // local
  InvalidAudienceName: 'Manage_Error_InvalidAudienceName', // local

  InvalidAudienceDescription: 'Manage_Error_InvalidAudienceDescription', // local
  InvalidAudienceConstraints: 'Manage_Error_InvalidAudienceConstraints',
  AudiencesNotPassed: 'Manage_Error_AudiencesNotPassed',
  InvalidAudienceStatus: 'Manage_Error_InvalidAudienceStatus',
  InvalidAudienceLookbackWindow: 'Manage_Error_InvalidAudienceLookbackWindow', // local
  InvalidAudienceCustomEventValue: 'Manage_Error_InvalidAudienceCustomEventValue',

  /* Tag related error codes */
  InvalidTagName: 'Manage_Error_InvalidTagName', // local
  InvalidTagDescription: 'Manage_Error_InvalidTagDescription', // local
  InvalidTagId: 'Manage_Error_InvalidTagId',
  TagIdsNotPassed: 'Manage_Error_TagIdsNotPassed',
  InvalidAudienceTagId: 'Manage_Error_InvalidAudienceTagId',
  TagsNotPassed: 'Manage_Error_TagsNotPassed',
  InvalidTagTrackingCode: 'Manage_Error_InvalidTagTrackingCode',
  InvalidTagStatus: 'Manage_Error_InvalidTagStatus',
  DuplicateTagId: 'Manage_Error_DuplicateTagId',
  DuplicateProductAudience: 'Manage_Error_DuplicateAudience',
  TagsBatchSizeExceesdLimit: 'Manage_Error_TagsBatchSizeExceesdLimit',
  TagWithSameNameAlreadyExistsUnderCustomer: 'UnifiedEventTracking_Tags_DuplicateTagNameError',
  /* Settings and configuration related */
  AudienceBidBoostingNotEnabledForCustomer: 'Manage_Error_AudienceBidBoostingNotEnabledForCustomer',
  AudienceBatchSizeExceedsLimit: 'Manage_Error_AudienceBatchSizeExceedsLimit',
  MaxAudiencesPerCustomerLimitReached: 'Manage_Error_MaxAudiencesPerCustomerLimitReached',
  MaxAudiencesPerAccountLimitReached: 'Manage_Error_MaxAudiencesPerAccountLimitReached',

  /* Service level errors */
  MdsServiceError: 'Manage_Error_MdsServiceError',

  /* audience grid related */
  AdGroupCriterionsEntityLimitExceeded: 'Manage_Error_AdgroupCriterionsEntityLimitExceeded',
  CampaignCriterionsEntityLimitExceeded: 'Manage_Error_CampaignCriterionsEntityLimitExceeded',
  MaxAudienceCriterionsPerAccountLimitReached: 'Manage_Error_MaxAudienceCriterionsPerAccountLimitReached',
  MaxInMarketAudienceExclusionPerAccountLimitReached: 'Error_Campaign_API_MaxInMarketAudienceExclusionPerAccountLimitReached',
  AudienceDeliveryChannelNotMatchCampaignType: 'Error_Campaign_API_AudienceDeliveryChannelNotMatchCampaignType',
  NonAudienceCampaignImpressionCannotBeUsedByNonAudienceCampaign: 'AudienceAssociation_IBR_Warning_Message',

  // impression-based
  DuplicatedEntityIdAndTypeForImpressionBasedRemarketingList: 'DuplicatedEntityIdAndTypeForImpressionBasedRemarketingList',

  DefaultError: 'Manage_Error_Default',
};
